export default "__VITE_PUBLIC_ASSET__8e67da7d__"